












import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import RoutineList from '@/components/RoutineList.vue'
import RoutineMixin from '@/mixins/RoutineMixin'

@Component({
  components: { RoutineList }
})
export default class RoutineInfo extends Mixins(RoutineMixin) {
  @Prop({ default: '' }) routineId!: string

  navigateBack () {
    this.$router.push({ name: 'routine-finder' })
  }

  navigateToRoutinePlayer () {
    this.$router.push({ name: 'routine-player', params: { routineId: this.routineId } })
  }
}
